export enum RVReportFrequency {
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}
